export const cleanObject = (payload: { [key: string]: any }): { [key: string]: any } =>
  Object.keys(payload)
    .filter((key: string) => payload[key] !== '' && payload[key] !== null)
    .reduce((obj: { [key: string]: any }, key: string) => {
      obj[key] = payload[key];
      return obj;
    }, {});
